module.exports = __webpack_public_path__ + "img/android_y.ddc6bdb4.png";